'use client'

import {useContext, useState} from 'react'
import {Dialog, DialogPanel} from '@headlessui/react'
import {Bars3Icon, XMarkIcon} from '@heroicons/react/24/outline'
import {Link} from 'react-router-dom'
import Logo from 'components/generic/Logo'
import {AppContext} from 'context/AppContext'
import APP_CONFIG from 'constants/clientConfigs'

const {
  primaryColor = '',
  siteName,
  bgColor,
  clientUrl,
  discountsText,
  discountText,
} = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

const slug = JSON.parse(localStorage.getItem('user'))?.store?.slug||'';

const navigation = [
  {name: 'My Store', href: 'my-store'},
  {name: discountsText, href: 'coupons'},
  {name: 'Payment', href: 'payment'},
  {
    name: `Live ${discountText} Page`,
    target: '_blank',
    href: `${clientUrl}${slug ?? ''}`,
  },
]

export default function AppHeader() {
  const {user} = useContext(AppContext)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const authenticated =
    !!user?.id || !!JSON.parse(localStorage.getItem('user'))?.id


  return (
    <header className="bg-white">
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between gap-x-6 p-6 lg:px-8">
        <div className="flex lg:flex-1">
          {/* <a href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span> */}
          <Link
            to="/"
            title={siteName}
            aria-label={siteName}
            className="pt-2 min-w-fit"
            style={{width: 180}}>
            <Logo />
          </Link>
          {/* </a> */}
        </div>

        <div className="flex flex-1 items-center justify-end gap-x-6">
          {authenticated && (
            <div className="hidden lg:flex lg:gap-x-12">
              {navigation.map(item => (
                <>
                  {item.target === '_blank' ? (
                    <a
                      key={item.name}
                      href={item.href}
                      target={item.target}
                      className="text-sm/6 font-semibold text-gray-900">
                      {item.name}
                    </a>
                  ) : (
                    <Link
                      key={item.name}
                      to={item.href}
                      target={item.target}
                      className="text-sm/6 font-semibold text-gray-900">
                      {item.name}
                    </Link>
                  )}
                </>
              ))}
            </div>
          )}
          {!authenticated ? (
            <>
              <Link
                to="/login"
                className="hidden text-sm/6 font-semibold text-gray-900 lg:block">
                Log in
              </Link>
              <Link
                to="/register"
                className={`rounded-md ${bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-${primaryColor}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${primaryColor}-600`}>
                Create your coupon page
              </Link>
            </>
          ) : (
            <Link
              to="/logout"
              className={`rounded-md ${bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-${primaryColor}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${primaryColor}-600`}>
              Logout
            </Link>
          )}
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700">
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
      </nav>
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center gap-x-6">
            <Link
              to="/"
              title={siteName}
              aria-label={siteName}
              className="pt-2 min-w-fit"
              style={{width: 180}}>
              <Logo />
            </Link>

            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700">
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              {authenticated && (
                <div className="space-y-2 py-6">
                  {navigation.map(item => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                      {item.name}
                    </a>
                  ))}
                </div>
              )}
              <div className="py-6">
                {!authenticated ? (
                  <>
                    <Link
                      to="/login"
                      className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                      Log in
                    </Link>
                    <Link
                      to="/register"
                      className={`ml-auto rounded-md ${bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-${primaryColor}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600`}>
                      Create your coupon page
                    </Link>
                  </>
                ) : (
                  <Link
                    to="/logout"
                    className={`rounded-md ${bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-${primaryColor}-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${primaryColor}-600`}>
                    Logout
                  </Link>
                )}
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  )
}
